import { actions as formActions } from 'react-redux-form'

import * as h2Api from '../h2Api'

export const LOAD_INTAKE_FORM = 'LOAD_INTAKE_FORM'
export const CREATE_FORM = 'CREATE_INTAKE_FORM'
export const CREATE_ADDITIONAL_FORM = 'CREATE_ADDITIONAL_INTAKE_FORM'
export const CALLBACK_INTAKE_FORM = 'CALLBACK_INTAKE_FORM'
export const SET_ADDITIONAL_JSON = 'SET_ADDITIONAL_JSON'
export const LOAD_META = 'LOAD_META'

export const loadIntakeForm = id => dispatch => {
  return dispatch(h2Api.get(`/profiles/intake/${id}`)({ type: LOAD_INTAKE_FORM })).then(
    v => {
      // console.log(v)

      const reqFields = {}

      v.sections.forEach(s => {
        s.fields
          .filter(f => !!f.required)
          .forEach(f => (reqFields[`${s.sectionKey}-${f.key}`] = ''))

        if (s.hasOwnProperty('associatedRecordFields')) {
          reqFields[`${s.sectionKey}-associatedRecordFields`] = [{}]
          s.associatedRecordFields
            .filter(f => !!f.required)
            .forEach(
              f => (reqFields[`${s.sectionKey}-associatedRecordFields`][0][f.key] = '')
            )
        }
      })

      dispatch(formActions.merge('localOpportunities.profileLoad.form', reqFields))
      //console.log(reqFields)

      return v
    }
  )
}

export const setAdditionalJson = json => dispatch => {
  dispatch({ type: SET_ADDITIONAL_JSON, additionalJson: json })
}

export const removeAssociatedRecord = (formName, sectionKey, idx) => dispatch => {
  dispatch(formActions.remove(`${formName}.${sectionKey}-associatedRecordFields`, idx))
}

export const addAssociatedRecord = (formName, sectionKey, modelRecs) => dispatch => {
  const reqFields = {}

  modelRecs.filter(f => !!f.required).forEach(f => (reqFields[f.key] = ''))

  //console.log(`${formName}.${sectionKey}-associatedRecordFields`, reqFields)

  dispatch(
    formActions.push(`${formName}.${sectionKey}-associatedRecordFields`, reqFields)
  )
}

export const doCallback = (url, sectionKey, data) => dispatch => {
  dispatch(h2Api.post(url, { data })({ type: CALLBACK_INTAKE_FORM, sectionKey }))
}

export const createProfileFromIntakeForm = (id, form) => dispatch => {
  return dispatch(h2Api.post(`/profiles/intake/${id}`, form)({ type: CREATE_FORM }))
}

export const getIntakeMeta = form => dispatch => {
  return dispatch(h2Api.post(`/profiles/intake/meta`, form)({ type: LOAD_META }))
}

export const updateProfileFromIntakeForm = (url, form) => dispatch => {
  return dispatch(h2Api.put(url, form)({ type: CREATE_ADDITIONAL_FORM }))
}
